export { default } from './LPThankYouPage';
